import { Injectable, OnInit } from '@angular/core';
import { Constants } from '../../constants/constants.service';


@Injectable()
export class DataService implements OnInit
{
    constructor(){
    }

    ngOnInit(){}
    createFormData(object: Object, form?: FormData, namespace?: string): FormData {
        const formData = form || new FormData();
        for (let property in object) {
            if (!object.hasOwnProperty(property) || !object[property]) {
                continue;
            }
            const formKey = namespace ? `${namespace}[${property}]` : property;
            if (object[property] instanceof Date) {
                formData.append(formKey, object[property].toISOString());
            } else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
                this.createFormData(object[property], formData, formKey);
            } else {
                formData.append(formKey, object[property]);
            }
        }
        return formData;
    }

    utf8_to_b64( str ) {
      return btoa(str);
    }

    b64_to_utf8( str ) {
      return atob(str);
    }

    validaRut(rutCompleto) {
  		if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
  			return false;
  		var tmp 	= rutCompleto.split('-');
  		var digv	= tmp[1];
  		var rut 	= tmp[0];
  		if ( digv == 'K' ) digv = 'k' ;
  		return (this.dv(rut) == digv );
  	}

  	dv(T){
  		var M=0,S=1;
  		for(;T;T=Math.floor(T/10))
  			S=(S+T%10*(9-M++%6))%11;
  		return S?S-1:'k';
  	}
}



// WEBPACK FOOTER //
// ./src/app/services/utils/data/data.service.ts